import { FlosIcon } from '@flos/react-ui';

const SaveIndicator = () => {
    return (
        <div className="u-spacing-stack-top-2 save-indicator">
            <FlosIcon shape="circle-check-animated" size="small" className="has-fill is-green" />
            <span className="u-color-secondary-4-medium">Gemt</span>
        </div>
    );
};

export default SaveIndicator;
